module.exports = __webpack_public_path__ + "static/media/tm.7e7e99f5.svg";